import SectionHeading from '@/pages/home/components/SectionHeading';
import { heatRank, updateRank } from '@/mocks/home';

export default function RankingSection() {
  const [top, ...others] = heatRank;

  return (
    <section id="rank" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1440px] px-4 md:px-8">
        <SectionHeading
          no="03"
          title="热度双榜"
          en="Ranking"
          desc="热度榜看话题有多热，更新榜看它多久动一次，两张榜一起读更准。"
          right={
            <span className="flex items-center gap-1.5 whitespace-nowrap text-xs text-foreground-500">
              <i className="ri-refresh-line text-sm" />
              每 10 分钟滚动更新
            </span>
          }
        />

        <div className="grid gap-5 lg:grid-cols-2">
          <div className="overflow-hidden rounded-lg bg-foreground-950 text-background-50">
            <div className="flex items-center justify-between border-b border-background-50/10 px-5 py-4">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold">
                <i className="ri-fire-fill text-lg text-primary-500" />
                热搜榜
              </h3>
              <span className="font-label text-[11px] uppercase tracking-[0.2em] text-background-400">
                Top 10
              </span>
            </div>

            <div className="flex items-center gap-4 bg-primary-500/10 px-5 py-4">
              <span className="flex h-14 w-14 flex-none items-center justify-center rounded-md bg-primary-500 font-label text-3xl font-bold text-background-50">
                1
              </span>
              <div className="min-w-0">
                <p className="truncate font-heading text-lg font-bold text-background-50">
                  {top.term}
                </p>
                <p className="mt-1 flex items-center gap-3 text-xs text-background-300">
                  <span className="flex items-center gap-1">
                    <i className="ri-line-chart-line text-sm text-accent-500" />
                    {top.heat}
                  </span>
                  <span className="flex items-center gap-1 text-accent-500">
                    <i className="ri-arrow-up-line text-sm" />
                    上升中
                  </span>
                </p>
              </div>
            </div>

            <ul className="px-5 py-2">
              {others.map((item) => (
                <li
                  key={item.rank}
                  className="flex items-center gap-4 border-b border-background-50/8 py-3 last:border-0"
                >
                  <span className="w-6 flex-none font-label text-base font-semibold text-background-400">
                    {String(item.rank).padStart(2, '0')}
                  </span>
                  <span className="min-w-0 flex-1 truncate text-sm text-background-100">
                    {item.term}
                  </span>
                  <span className="flex flex-none items-center gap-2 text-xs text-background-400">
                    {item.heat}
                    <i
                      className={`text-sm ${
                        item.delta === 'up' ? 'ri-arrow-up-line text-primary-400' : 'ri-arrow-down-line text-background-500'
                      }`}
                    />
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <div className="flex items-center justify-between border-b border-background-200 bg-background-50 px-5 py-4">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-flashlight-line text-lg text-secondary-600" />
                更新榜
              </h3>
              <span className="font-label text-[11px] uppercase tracking-[0.2em] text-foreground-400">
                Latest
              </span>
            </div>

            <ul className="divide-y divide-background-200">
              {updateRank.map((item, index) => (
                <li key={`${item.title}-${index}`} className="flex items-start gap-4 px-5 py-3.5">
                  <span className="mt-0.5 flex-none rounded bg-background-50 px-2 py-0.5 font-label text-[11px] font-semibold text-secondary-700">
                    {item.time}
                  </span>
                  <span className="min-w-0 flex-1 text-sm leading-snug text-foreground-800">
                    {item.title}
                  </span>
                  <span className="mt-0.5 flex-none rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900">
                    {item.type}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}